// BrowseHome.js
import { connect } from 'react-redux';
import withRouter from '../component/WithRouter.jsx';

import BrowseHome from '../page/BrowseHome.jsx';

import { FOLLOWING_PAGE_REQUIREMENT } from '../RemoteConfigKeys.js';
import { SEARCH_MODAL_ID } from '../resource/searchConstants.js';
import getMeData from '../selector/getMeData.js';
import getModalData from '../selector/getModalData.js';
import getNetworkingSummary from '../selector/getNetworkingSummary.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import fetchFollowingTotalCount from '../action/fetchFollowingTotalCount.js';

const mapStateToProps = state => {
  const isSearchModalOpened = ['opening', 'display'].includes(
    getModalData(state, SEARCH_MODAL_ID, 'status')
  );
  const shouldRenderSearchBar = !isSearchModalOpened;
  const fetchFollowingCountStatus = getNetworkingSummary(state, [
    'me',
    'following',
  ]);
  return {
    isAuthed: !!getMeData(state, 'id'),
    token: getMeData(state, 'token'),
    shouldRenderSearchBar,
    followingCount: getMeData(state, 'following'),
    fetchFollowingCountStatus,
    followingPageRequirement: getRemoteConfigData(
      state,
      FOLLOWING_PAGE_REQUIREMENT
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFollowingTotalCount: () => dispatch(fetchFollowingTotalCount()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BrowseHome)
);
